import React from 'react';
import { observer } from "mobx-react"

import UIStore from '../store/store';
import API from '../helpers/api';

import Sidebar from '../components/Sidebar';
import MapComponent from '../components/Map';
import Header from '../components/Header';

import '../App.css';

@observer
class App extends React.Component {
  onClick(props, marker) {
    const { city } = props;
    const { selectedCity, showSidebar } = UIStore;

    if (selectedCity === city) {
      return;
    }

    UIStore.selectedCity = city;

    // if sidebar open and new city clicked, return
    if (UIStore.showSidebar && city !== UIStore.selectedCity) {
        return;
    }



    UIStore.showSidebar = !UIStore.showSidebar;
  }

  mapClick() {
    UIStore.showSidebar = false;
  }

  onTypeSelected(e) {
    UIStore.selectedType = e.target.value;
  }

  render() {
    const { showSidebar, selectedCity, selectedType } = UIStore;
    const markerData = UIStore.getMarkerData;

    return (
      <div style={styles.container}>
        <Header 
          onTypeSelected={(e) => this.onTypeSelected(e)}
        />

        <div style={{ display: 'flex', flex: 1 }}>
          <MapComponent
            markerData={markerData}
            onClick={(props, marker, e) => this.onClick(props, marker, e)}
            onMapClick={() => this.mapClick()}
            likedPoints={UIStore.likedPoints}
          />
          <Sidebar 
            selectedCity={selectedCity}
            showSidebar={showSidebar}
            mapClick={() => this.mapClick()} 
          />
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  }
}

export default App;
